import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import LoginPage from '../LoginPage/LoginPage';


const baseUrl = process.env.REACT_APP_BASE_URL;
const userPhoneNumber = localStorage.getItem('user');

function BookDetailPage() {
    const { mainCategory, category, bookName } = useParams();
    const navigate = useNavigate();
    const audioRef = useRef(null);
    const [book, setBook] = useState(null);
    const [currentStream, setCurrentStream] = useState(null);
    const [loadingTopics, setLoadingTopics] = useState(false);
    const [topics, setTopics] = useState({});
    const [isPaused, setIsPaused] = useState(true);
    const [loading, setLoading] = useState(false);
    const liveRegionRef = useRef(null);
    const [loadingResume, setLoadingResume] = useState(false);
    const [loadingPlayPause, setLoadingPlayPause] = useState(false);
    const [loadingNext, setLoadingNext] = useState(false);
    const [loadingPrev, setLoadingPrev] = useState(false);
    const [loadingChapters, setLoadingChapters] = useState({});

    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const [error, setError] = useState(null);
    const [message, setMessage] = useState('');

    const [hasEnded, setHasEnded] = useState(false);
    const [firstPlayback, setFirstPlayback] = useState(true);

    let intervalId;
    const savePlaybackProgress = async (currentTime) => {
        try {
            await axios.post(`${baseUrl}/ivr/save/${book.bookAwsName}/${userPhoneNumber}`, {
                lastPlaybackTime: currentTime,
            });
            console.log(`Progress saved: ${currentTime}s`);
        } catch (err) {
            console.error('Error saving progress:', err.message);
        }
    };
    const handleEnded = async () => {
        if (!hasEnded) {
            setHasEnded(true);




            if (audioRef != null && audioRef.current) {
                await handlePlayNext();
            }



        }
    };

    useEffect(() => {
        const user = localStorage.getItem('user');
        if (user) {
            setIsLoggedIn(true);
            updateLoginTimestamp(user);
            fetchBook().then((audiobook) => {
                fetchTopics(audiobook);
            })
        } else {
            setIsLoggedIn(false);
        }
    }, []);


    const updateLoginTimestamp = async (phone) => {
        try {
            const response = await axios.get(`${baseUrl}/ivr/user/updateLoginTimestamp/${phone}`);
            return response.data;
        } catch (error) {
            console.error('Error updating:', error);
            return null;
        }
    };

    const fetchBook = async () => {
        setMessage('');
        setError('');
        setLoadingTopics(true);
        try {
            const response = await axios.get(`${baseUrl}/ivr/book/${bookName}`);
            setBook(response.data);
            return response.data;
        } catch (error) {
            console.error('Error fetching topics:', error);
            return null;
        }
    };

    const fetchTopics = async (audiobook) => {
        setMessage('');
        setError('');
        setLoadingTopics(true);
        const bookName = audiobook.bookAwsName;
        if (!topics[bookName]) { // Check if topics for this book have already been fetched
            try {
                const response = await axios.get(`${baseUrl}/ivr/getBookTopics/${bookName}`);
                setTopics((prev) => ({ ...prev, [bookName]: response.data })); // Store topics
                console.log(topics)
            } catch (error) {
                console.error('Error fetching topics:', error);
            }
        }
    };

    const handlePlay = async () => {
        setMessage('');
        setError('');
        try {
            setLoadingPlayPause(true);
            announceMessage('Loading audio...');
            setTimeout(async () => {
                try {
                    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ivr/play/${book.bookAwsName}/${userPhoneNumber}`, {
                        responseType: 'blob'
                    });
                    setLoadingPlayPause(false);
                    announceMessage('Audio loaded, ready to play.');
                    const audioUrl = URL.createObjectURL(response.data);
                    audioRef.current.src = audioUrl;

                    // Wait for the audio to be ready before playing
                    audioRef.current.oncanplaythrough = () => {
                        setIsPaused(false);
                        setHasEnded(false);
                        audioRef.current.play().catch((error) => {
                            console.error('Error attempting to play:', error);
                        });
                        intervalId = setInterval(() => {
                            const currentTime = Math.floor(audioRef.current.currentTime);
                            savePlaybackProgress(currentTime);
                            console.log("at handlePlay");
                        }, 10000);
                    };
                    audioRef.current.onended = () => {
                        setIsPaused(true);
                        setHasEnded(true);
                        clearInterval(intervalId);
                        console.log('Audio playback ended.');
                    };
                    audioRef.current.onpause = () => {
                        setIsPaused(true);
                        clearInterval(intervalId);
                        console.log('Audio playback paused.');
                    };
                    setCurrentStream(audioUrl);
                } catch (err) {
                    setLoadingPlayPause(false);
                    announceMessage('Failed to load audio.');
                    setError(err.message);
                }
            }, 100);
        } catch (err) {
            setLoadingPlayPause(false);
            announceMessage('Failed to load audio.');
            console.error("Error preparing to play article audio:", err);
        }
        setFirstPlayback(false);
    };

    const handlePlayNext = async () => {
        setMessage('');
        setError('');
        try {
            setLoadingNext(true);
            announceMessage('Loading audio...');
            setTimeout(async () => {
                try {
                    if (audioRef.current) {
                        audioRef.current.pause();
                        setIsPaused(true);
                        clearInterval(intervalId);
                    }
                    const playbackResponse = await axios.get(`${process.env.REACT_APP_BASE_URL}/ivr/getPlaybackProgress/${book.bookAwsName}/${userPhoneNumber}`);
                    const lastPlaybackTime = playbackResponse.data.lastPlaybackTime || 0;
                    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ivr/section/next/${book.bookAwsName}/${userPhoneNumber}`, {
                        responseType: 'blob'
                    });
                    setLoadingNext(false);
                    const audioUrl = URL.createObjectURL(response.data);
                    audioRef.current.src = audioUrl;

                    audioRef.current.currentTime = 0;
                    audioRef.current.oncanplaythrough = () => {
                        setIsPaused(false);
                        setHasEnded(false);
                        audioRef.current.play().catch((error) => {
                            console.error('Error attempting to play:', error);
                        });
                        intervalId = setInterval(() => {
                            const currentTime = Math.floor(audioRef.current.currentTime);
                            savePlaybackProgress(currentTime + lastPlaybackTime);
                            console.log("at handlePlayNext");
                        }, 10000);
                    };

                    audioRef.current.onended = () => {
                        setIsPaused(true);
                        setHasEnded(true);
                        clearInterval(intervalId);
                        console.log('Audio playback ended.');
                    };
                    audioRef.current.onpause = () => {
                        setIsPaused(true);
                        clearInterval(intervalId);
                        console.log('Audio playback paused.');
                    };
                    setCurrentStream(audioUrl);
                } catch (err) {
                    if (err.status === 404) {
                        //no more pages
                        setMessage('No more sections or pages to play');
                        return;
                    }
                    setLoadingNext(false);
                    announceMessage('Failed to load audio.');
                    setError(err.message);
                }
            }, 100);
        } catch (err) {
            setLoadingNext(false);
            announceMessage('Failed to load audio.');
            console.error("Error preparing to play article audio:", err);
        }
        setFirstPlayback(false);
    };


    const handlePlayPrev = async () => {
        setMessage('');
        setError('');
        try {
            setLoadingPrev(true);
            announceMessage('Loading audio...');
            setTimeout(async () => {
                try {
                    if (audioRef.current) {
                        audioRef.current.pause();
                        setIsPaused(true);
                        clearInterval(intervalId);
                    }
                    const playbackResponse = await axios.get(`${process.env.REACT_APP_BASE_URL}/ivr/getPlaybackProgress/${book.bookAwsName}/${userPhoneNumber}`);
                    const lastPlaybackTime = playbackResponse.data.lastPlaybackTime || 0;
                    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ivr/section/prev/${book.bookAwsName}/${userPhoneNumber}`, {
                        responseType: 'blob'
                    });
                    setLoadingPrev(false);
                    const audioUrl = URL.createObjectURL(response.data);
                    audioRef.current.src = audioUrl;

                    // Wait for the audio to be ready before playing
                    audioRef.current.oncanplaythrough = () => {
                        setIsPaused(false);
                        setHasEnded(false);
                        audioRef.current.play().catch((error) => {
                            console.error('Error attempting to play:', error);
                        });
                        intervalId = setInterval(() => {
                            const currentTime = Math.floor(audioRef.current.currentTime);
                            savePlaybackProgress(currentTime + lastPlaybackTime);
                            console.log("at handlePlayNext");
                        }, 10000);
                    };

                    audioRef.current.onended = () => {
                        setIsPaused(true);
                        setHasEnded(true);
                        clearInterval(intervalId);
                        console.log('Audio playback ended.');
                    };
                    audioRef.current.onpause = () => {
                        setIsPaused(true);
                        clearInterval(intervalId);
                        console.log('Audio playback paused.');
                    };
                    setCurrentStream(audioUrl);
                } catch (err) {
                    if (err.status === 404) {
                        //no more pages
                        setMessage('No more sections or pages to play');
                        return;
                    }
                    setError(err.message);
                    setLoadingPrev(false);
                    announceMessage('Failed to load audio.');
                }
            }, 100);
        } catch (err) {
            setLoadingPrev(false);
            announceMessage('Failed to load audio.');
            console.error("Error preparing to play article audio:", err);
        }
        setFirstPlayback(false);
    };

    const handlePause = () => {
        setMessage('');
        setError('');
        if (audioRef.current) {

            audioRef.current.pause();
            setIsPaused(true);
        }
    };


    const handlePlayChapter = async (topicIndex) => {
        setMessage('');
        setError('');
        setLoadingChapters((prev) => ({ ...prev, [topicIndex]: true }));
        try {
            announceMessage('Loading audio...');
            setTimeout(async () => {
                try {
                    setIsPaused(true);
                    if (audioRef.current) {
                        audioRef.current.pause();
                    }
                    const playbackResponse = await axios.get(
                        `${process.env.REACT_APP_BASE_URL}/ivr/getPlaybackProgress/${book.bookAwsName}/${userPhoneNumber}`
                    );
                    const lastPlaybackTime = playbackResponse.data.lastPlaybackTime || 0;
                    const response = await axios.get(
                        `${process.env.REACT_APP_BASE_URL}/ivr/section/play/${book.bookAwsName}/${topicIndex}/${userPhoneNumber}`,
                        { responseType: 'blob' }
                    );
                    // Set loading to false only for this chapter
                    setLoadingChapters((prev) => ({ ...prev, [topicIndex]: false }));
                    const audioUrl = URL.createObjectURL(response.data);
                    audioRef.current.src = audioUrl;
                    if (response.headers['clip-begin']) {
                        const startTime = response.headers['clip-begin'].split('=')[1].replace('s', '');
                        audioRef.current.currentTime = startTime;
                    }

                    audioRef.current.oncanplaythrough = () => {
                        setIsPaused(false);
                        setHasEnded(false);
                        audioRef.current.play().catch((error) => {
                            console.error('Error attempting to play:', error);
                        });

                        intervalId = setInterval(() => {
                            const currentTime = Math.floor(audioRef.current.currentTime);
                            savePlaybackProgress(firstPlayback ? currentTime : currentTime + lastPlaybackTime);
                            console.log("Saving playback progress...");
                        }, 10000);
                    };

                    audioRef.current.onended = () => {
                        setIsPaused(true);
                        setHasEnded(true);
                        clearInterval(intervalId);
                        console.log('Audio playback ended.');
                    };

                    audioRef.current.onpause = () => {
                        setIsPaused(true);
                        clearInterval(intervalId);
                        console.log('Audio playback paused.');
                    };

                    setCurrentStream(audioUrl);
                } catch (err) {
                    setLoadingChapters((prev) => ({ ...prev, [topicIndex]: false }));

                    if (err.status === 404) {
                        setMessage('No more sections or pages to play');
                        return;
                    }
                    setError(err.message);
                    announceMessage('Failed to load audio.');
                    console.error("Error preparing to play article audio:", err);
                }
            }, 100);
        } catch (err) {
            setLoadingChapters((prev) => ({ ...prev, [topicIndex]: false }));
            announceMessage('Failed to load audio.');
            console.error("Error preparing to play article audio:", err);
        }
        setFirstPlayback(false);
    };


    const handleResumePlay = async (topicIndex) => {
        setMessage('');
        setError('');
        try {
            setLoadingResume(true);
            announceMessage('Loading audio...');
            setTimeout(async () => {
                try {
                    if (audioRef.current) {
                        audioRef.current.pause();
                        setIsPaused(true);
                    }
                    const playbackResponse = await axios.get(`${process.env.REACT_APP_BASE_URL}/ivr/getPlaybackProgress/${book.bookAwsName}/${userPhoneNumber}`);
                    const lastPlaybackTime = playbackResponse.data.lastPlaybackTime || 0;
                    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ivr/getProgress/${book.bookAwsName}/${userPhoneNumber}`, {

                        responseType: 'blob'
                    });
                    setLoadingResume(false);
                    const audioUrl = URL.createObjectURL(response.data);
                    audioRef.current.src = audioUrl;
                    if (response.headers['clip-begin']) {
                        const startTime = response.headers['clip-begin'].split('=')[1].replace('s', '');
                        audioRef.current.currentTime = startTime;
                    }

                    // Wait for the audio to be ready before playing
                    audioRef.current.oncanplaythrough = () => {
                        setIsPaused(false);
                        setHasEnded(false);
                        audioRef.current.play().catch((error) => {
                            console.error('Error attempting to play:', error);
                        });
                        intervalId = setInterval(() => {
                            const currentTime = Math.floor(audioRef.current.currentTime);
                            savePlaybackProgress(firstPlayback ? currentTime : currentTime + lastPlaybackTime);
                            console.log("Saving playback progress...");
                        }, 10000);
                    };

                    audioRef.current.onended = () => {
                        setIsPaused(true);
                        setHasEnded(true);
                        clearInterval(intervalId);
                        console.log('Audio playback ended.');
                    };
                    audioRef.current.onpause = () => {
                        setIsPaused(true);
                        clearInterval(intervalId);
                        console.log('Audio playback paused.');
                    };
                    setCurrentStream(audioUrl);
                } catch (err) {
                    if (err.status == 404) {
                        //no more pages
                        setMessage('No more sections or pages to play');
                        return;
                    }
                    setError(err.message);
                    setLoadingResume(false);
                    announceMessage('Failed to load audio.');
                }
            }, 100);
        } catch (err) {
            setLoadingResume(false);
            announceMessage('Failed to load audio.');
            console.error("Error preparing to play article audio:", err);
        }
        setFirstPlayback(false);
    };

    const announceMessage = (message) => {
        if (liveRegionRef.current) {
            liveRegionRef.current.textContent = '';
            setTimeout(() => {
                liveRegionRef.current.textContent = message;
            }, 100);
        }
    };

    return isLoggedIn ?
        (
            <div className='container'>
                <section className="header-wrap d-flex justify-content-start align-items-center">
                    <button
                        onClick={() => { handlePause(); navigate(-1); }}
                        className="btn btn-secondary"
                        aria-label="Go back to previous page"
                    >
                        Go Back
                    </button>
                    <h1 className="logo my-auto ms-4">
                        <span className="assistive-text">Shravan Audiobooks Library</span>
                    </h1>
                </section>

                <div className="main-content mt-5">
                    {book && (
                        <div className="page book-page">
                            <div className="content-wrap clearfix">
                                <h2 className='text-primary' aria-label={'Book: ' + book.bookName} >{book.bookName}</h2>
                                <h3 className="book-page-author me-3 fw-semibold">Author: {book.author}</h3>
                                <h3 className="book-page-category me-3 fw-semibold">Category: {book.category}</h3>
                                <h3 className="book-page-language fw-semibold">Language: {book.language}</h3>
                            </div>

                            <audio
                                aria-describedby="audio-desc"
                                ref={audioRef}
                                autoPlay
                                onEnded={handleEnded}
                            >
                                <source src={currentStream} type='audio/mp3' />
                                Your browser does not support the audio element.
                            </audio>
                            <p id="audio-desc" className="visually-hidden">
                                Press Play to start the audiobook. Use Next and Previous to navigate chapters.
                            </p>
                            {/* Live Region (Keeps Existing Announcement Function) */}
                            <div
                                ref={liveRegionRef}
                                aria-live="assertive"
                                role="status"
                                style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', overflow: 'hidden' }}
                            ></div>
                            <div className='d-flex flex-wrap'>
                                {loadingResume ? (
                                    <div className="mx-3 spinner-border text-primary" role="status"></div>
                                ) : (
                                    <Button
                                        className='mx-2'
                                        variant="primary"
                                        onClick={handleResumePlay}
                                        aria-label={`Resume playing ${book.bookName}`}
                                    >
                                        Resume
                                    </Button>
                                )}

                                {loadingPlayPause ? (
                                    <div className="mx-3 spinner-border text-primary" role="status"></div>
                                ) : (
                                    <Button
                                        className='mx-2'
                                        variant="primary"
                                        onClick={isPaused ? handlePlay : handlePause}
                                        aria-label={`${isPaused ? 'Play' : 'Pause'} ${book.bookName}`}
                                    >
                                        {isPaused ? 'Play' : 'Pause'}
                                    </Button>
                                )}

                                {loadingNext ? (
                                    <div className="mx-3 spinner-border text-primary" role="status"></div>
                                ) : (
                                    <Button
                                        className='mx-2'
                                        variant="primary"
                                        onClick={handlePlayNext}
                                        aria-label={`Play next chapter of ${book.bookName}`}
                                    >
                                        Play Next Chapter
                                    </Button>
                                )}

                                {loadingPrev ? (
                                    <div className="mx-3 spinner-border text-primary" role="status"></div>
                                ) : (
                                    <Button
                                        className='mx-2'
                                        variant="primary"
                                        onClick={handlePlayPrev}
                                        aria-label={`Play previous chapter of ${book.bookName}`}
                                    >
                                        Play Previous Chapter
                                    </Button>
                                )}
                            </div>
                            <table className="chapter-list table table-striped mt-4">
                                <thead>
                                    <tr>
                                        <th scope="col">Action</th>
                                        <th scope="col">Type</th>
                                        <th scope="col">Title</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {book && topics[book.bookAwsName] && (
                                        topics[book.bookAwsName].map((chapter) => (
                                            <tr key={chapter.index}>
                                                <td>
                                                    {loadingChapters[chapter.index] ? (
                                                        <div className="mx-3 spinner-border text-primary" role="status"></div>
                                                    ) : (
                                                        <Button
                                                            className="mx-3"
                                                            variant="primary"
                                                            aria-label={`Play ${chapter.type} ${chapter.content}`}
                                                            onClick={() => handlePlayChapter(chapter.index)}
                                                        >
                                                            Play
                                                        </Button>
                                                    )}
                                                </td>
                                                <td>{chapter.type.toUpperCase()}</td>
                                                <td className="chapter-name">{chapter.content}</td>
                                            </tr>
                                        ))
                                    )}

                                </tbody>
                            </table>
                            <div role="alert">
                                {message && <p className='text-success'>{message}</p>}
                                {error && <p style={{ color: 'red' }}>Error: {error}</p>}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        ) : <LoginPage isStrictSearch={mainCategory === 'books'} />
}

export default BookDetailPage;
